import {
	AfterViewInit,
	Component,
	ChangeDetectionStrategy,
} from '@angular/core';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';
import { Router } from '@angular/router';
import { CellClickedEvent } from 'ag-grid-community';
import { CustomTableComponent } from '../../../../custom-table/custom-table.component';

@Component({
	selector: 'app-rapid-files-portal',
	templateUrl: './rapid-files-portal.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./rapid-files-portal.component.scss'],
	imports: [CustomTableComponent],
})
export class RapidFilesPortalComponent implements AfterViewInit {
	portalData: any;

	public gridApi_rapid: any;
	public gridApi_rapid_data: any;
	public gridColumnApi_rapid: any;

	rapidData: any;

	defaultColDef_rapid: any;
	public columnDefs_rapid = [];

	showLoader: boolean;
	constructor(
		private apiService: LegacyApiService,
		private router: Router
	) {
		this.columnDefs_rapid = [
			{
				headerName: 'Name',
				field: 'deal_name',
				filter: 'agTextColumnFilter',
				pinned: 'left',
				minWidth: 250,
				cellStyle: { cursor: 'pointer', color: '#116abd' },
			},
			{
				headerName: 'Stage',
				field: 'zoho_stage',
				filter: 'agTextColumnFilter',
				minWidth: 250,
			},
			{
				headerName: 'Agency',
				field: 'referral_company',
				filter: 'agTextColumnFilter',
				minWidth: 250,
			},
			{
				headerName: 'Amount',
				field: 'loan_amount',
				filter: 'agNumberColumnFilter',
				minWidth: 130,
			},
			{
				headerName: 'Homeowner',
				field: 'home_owner',
				filter: 'agTextColumnFilter',
				minWidth: 150,
			},
			{
				headerName: 'Loyalty',
				field: 'loyalty_program',
				filter: 'agTextColumnFilter',
				minWidth: 150,
			},
			{
				headerName: 'Created At',
				field: 'created_at',
				filter: 'agDateColumnFilter',
				minWidth: 130,
			},
			{
				headerName: 'Created By',
				field: 'full_name',
				filter: 'agTextColumnFilter',
				minWidth: 150,
			},
		];
		this.defaultColDef_rapid = {
			resizable: true,
		};
	}
	ngAfterViewInit(): void {
		this.portalData = this.apiService
			.getRapidFilesPortal()
			.subscribe((res: any) => {
				this.rapidData = res?.data;
				// console.log(this.rapidData, "++++")
				if (this.rapidData === false) {
					console.log('ZOHO error!');
				} else {
					this.gridApi_rapid?.setRowData(this.rapidData);
					this.gridApi_rapid_data = this.rapidData;
				}
			});
	}

	onGridReady(params: any): void {
		this.gridApi_rapid = params.api;
		this.showLoader = true;
		this.gridColumnApi_rapid = params.columnApi;
		this.gridApi_rapid?.setRowData(this.rapidData);
		this.gridApi_rapid_data = this.rapidData;
	}

	onCellClicked(e: CellClickedEvent) {
		const { zoho_applicationID } = e.data;
		const url = this.router.serializeUrl(
			this.router.createUrlTree(['/applications/summary', zoho_applicationID])
		);
		window.open(url, '_blank');
		// return this.router.navigate(['/applications/summary', id]);
	}

	ngOnDestroy() {
		this.portalData.unsubscribe();
	}
}
